// extracted by mini-css-extract-plugin
export var button = "_5p-7";
export var buttonRow = "_5p-6";
export var fadeIn = "_5p-1";
export var gradient = "_5p-0";
export var panel = "_5p-2";
export var panelIn = "_5p-3";
export var subtitle = "_5p-5";
export var title = "_5p-4";